export default "__VITE_ASSET__BxRVLdtu__"